<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">Lista de Consolidados</h3>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">

                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker slot-scope="{focus, blur}"
                                 @on-open="focus"
                                 @on-close="blur"
                                 :config="dates.config"
                                 class="form-control datepicker"
                                 @input="dateRangeChange"
                                 placeholder="Seleccione fecha"
                                 v-model="dates.range">
                    </flat-picker>
                  </base-input>
                </div>

              </div>



            </div>
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="reports"
            >
              <el-table-column label="Semana del año" prop="week_of_year" width="210px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.week_of_year}}</template>
              </el-table-column>
              <el-table-column label="Desde" prop="week" width="200px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.start}}</template>
              </el-table-column>
              <el-table-column label="Hasta" prop="name" width="200px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.end}}</template>
              </el-table-column>
              <el-table-column label="Tipo" prop="business_line_name" width="200px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.business_line_name}}</template>
              </el-table-column>
              <el-table-column label="Estado de pago" prop="payment_status" width="220px" min-width="200px" sortable>
                <template v-slot="{row}">
                  <badge v-if="row.payment_status.code !== 'unknown'" :type="gePaymentStatusColor(row.payment_status.code)" size="lg">
                    <h5 class="mb-0">{{row.payment_status.status}}</h5>
                  </badge>
                </template>
              </el-table-column>
               <el-table-column
                label="Facturar"
                prop="name"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">
                  <base-button
                    type="success"
                    @click="sendInvoice(row)"
                    v-if="!row.invoice"
                  >
                    <i class="far fa-file"></i> Facturar
                  </base-button>
                  <base-button
                    type="info"
                    @click="reSendInvoice(row)"
                    v-if="row.invoice"
                  >
                    <i class="far fa-file"></i> Reenviar Factura
                  </base-button>
                </template>
              </el-table-column>
              <el-table-column
                label="Acciones"
                prop="name"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">
                  <base-button
                    :loading="row.id === loading_id"
                    type="danger"
                    @click="get_pdf_func(row)"
                    v-if="row.is_downloable == 1"
                  >
                    <i class="far fa-file-pdf"></i> Descargar
                  </base-button>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Descargar PDF"
                prop="subgroup_id"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">
                  <a :href="baseUrl+date+'/'+user.data.catering_id+'/'+row.id">
                    <base-button type="danger">
                      <i class="far fa-file-pdf"></i> Descargar
                    </base-button>
                  </a>

                </template>
              </el-table-column>-->
            </el-table>
            <br />
          </div>
        </div>
        <CustomModal :is-modal="show_invoice"
                 @closeModal="show_invoice = false"
                 :closeOuth="true"
            >
              <form
                @submit.prevent="saveInvoice"
                id="navbar-search-main"
              >
              <div class="container">
                <div class="row">
                  <div class="mb-3 col-6">
                    <label for="serial_number" class="form-label">Número de Serie</label>
                    <input type="text" class="form-control" id="serial_number" v-model="invoice.serial_number" required>
                  </div>
                  <div class="mb-3 col-6">
                    <label for="voucher_number" class="form-label">Número de Comprobante</label>
                    <input type="text" class="form-control" id="voucher_number" v-model="invoice.voucher_number" required>
                  </div>
                </div>

                <div class="row">
                  <div class="mb-3 col-6">
                    <label for="date" class="form-label">Fecha</label>
                    <input type="date" class="form-control" id="date" v-model="invoice.date" required>
                  </div>
                  <div class="mb-3 col-6">
                    <label for="amount" class="form-label">Importe</label>
                    <input type="number" class="form-control" id="amount" v-model="invoice.amount" step="0.01" required>
                  </div>
                </div>

                <div class="row">
                  <div class="input-group mb-3 col-12">
                    <label class="input-group-text" for="invoice">Factura</label>
                    <input type="file" class="form-control" id="invoice"  @change="onFileChange" accept="image/*,application/pdf" required>
                  </div>
                </div>
                <div class="row" v-if="!loadSaveInvoice">
                  <div class="col-4 offset-1">
                      <button type="button" class="btn btn-danger" @click="closeModalInvoice" :disabled="loadSaveInvoice">
                        CANCELAR
                      </button>
                  </div>
                  <div class="col-4 offset-2">
                      <button type="submit" class="btn btn-success"  :disabled="loadSaveInvoice">
                        GUARDAR
                      </button>
                  </div>
                </div>
                <div class="row">
                  <div class="alert alert-success mt-4 col-12" role="alert" v-if="loadSaveInvoice" >
                   Enviando factura, por favor espere...
                  </div>
                </div>
              </div>
              </form>
              <template slot="footer">
                <button type="button" class="btn btn-link ml-auto" @click="closeModalInvoice">CERRAR</button>
              </template>
        </CustomModal>

        <CustomModal :is-modal="show_update_invoice"
                 @closeModal="show_update_invoice = false"
                 :closeOuth="true"
            >
              <form
                @submit.prevent="updateInvoice"
                id="navbar-search-main"
              >
              <div class="container">
                <div class="row">
                  <div class="mb-3 col-6">
                    <label for="serial_number" class="form-label">Número de Serie</label>
                    <input type="text" class="form-control" id="serial_number" v-model="invoice.serial_number" required>
                  </div>
                  <div class="mb-3 col-6">
                    <label for="voucher_number" class="form-label">Número de Comprobante</label>
                    <input type="text" class="form-control" id="voucher_number" v-model="invoice.voucher_number" required>
                  </div>
                </div>

                <div class="row">
                  <div class="mb-3 col-6">
                    <label for="date" class="form-label">Fecha</label>
                    <input type="date" class="form-control" id="date" v-model="invoice.date" required>
                  </div>
                  <div class="mb-3 col-6">
                    <label for="amount" class="form-label">Importe</label>
                    <input type="number" class="form-control" id="amount" v-model="invoice.amount" step="0.01" required>
                  </div>
                </div>
                <div class="row m-1">
                  Última factura enviada
                  <iframe width="400" height="400" :src="invoice.file"></iframe>
                </div>
                <div class="row">
                  <div class="input-group mb-3 col-12">
                    <label class="input-group-text" for="invoice">Factura</label>
                    <input type="file" class="form-control" id="invoice"  @change="onFileChange" accept="image/*,application/pdf">
                  </div>
                </div>
                <div class="row" v-if="!loadUpdateInvoice">
                  <div class="col-4 offset-1">
                      <button type="button" class="btn btn-danger" @click="closeModalUpdateInvoice" :disabled="loadUpdateInvoice">
                        CANCELAR
                      </button>
                  </div>
                  <div class="col-4 offset-2">
                      <button type="submit" class="btn btn-success"  :disabled="loadUpdateInvoice">
                        GUARDAR
                      </button>
                  </div>
                </div>
                <div class="row">
                  <div class="alert alert-success mt-4 col-12" role="alert" v-if="loadSaveInvoice" >
                   Enviando factura, por favor espere...
                  </div>
                </div>
              </div>
              </form>
              <template slot="footer">
                <button type="button" class="btn btn-link ml-auto" @click="closeModalInvoice">CERRAR</button>
              </template>
        </CustomModal>
      </div>
    </div>
  </div>
</template>
<script>
import backofficeApi from "../../gateways/backoffice-api";
import axios from "axios";
import moment from "moment";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es'
import CustomModal from "../../components/CustomModal";
import Swal from 'sweetalert2';

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CustomModal
  },
  data() {
    return {
      show_invoice: false,
      show_update_invoice: false,
      loading_id: false,
      name: "",
      user: [],
      currentPage: 1,
      selectedRows: [],
      date: new Date().toISOString().substr(0, 10),
      subgroups: [],
      totalIngredients: [],
      ingredientsByMeal: [],
      meals: [],
      baseUrlSnack: [],
      meals_ordered: [],
      meals_ordered_var: [],
      historicData: [],
      dates: {
        range: "",
        config:{allowInput: false, mode: 'range',locale: Spanish}
      },
      rangeDate:[],
      baseUrl: null,
      ingredients: [],
      reports: [],
      invoice: {
        serial_number: '',
        voucher_number: '',
        date: '',
        amount: '',
        consolidate_id: '',
        catering_id: '',
        date_ini: '',
        date_end: '',
        business_line_id: null,
      },
      previewUrl: '',
      loadSaveInvoice: false,
      loadUpdateInvoice: false
    };
  },
  created() {
    this.getUser();
  },
  mounted() {
    // this.get_historic_supplyLists();
    this.get_historic_consolidados();
  },
  watch:{
    rangeDate(val){
      //console.log(val)

    }
  },
  computed: {
    gePaymentStatusColor() {
      return (status) => {
        switch (status) {
          case "requested":
            return "info";
          case "partially_paid":
            return "warning";
          case "paid":
            return "success";
          default:
            return "info";
        }
      };
    },
  },
  methods: {
    dateRangeChange(val){
      const dates = val.split('a').map(item => {
        return item.trim()
      });
      dates.length === 2 ? this.rangeDate = dates : '';
      this.reports=[];
      this.get_historic_consolidados(this.rangeDate)
    },
    sendInvoice(item) {
      this.show_invoice = true
      this.invoice.consolidate_id = item.id
      this.invoice.catering_id = item.catering_id
      this.invoice.date_start = item.start
      this.invoice.date_end = item.end
      this.invoice.business_line_id = item.business_line_id

    },
    async reSendInvoice(item) {
      await this.getInvoice(item.id)
      this.show_update_invoice = true
      this.invoice.date_start = item.start
      this.invoice.date_end = item.end

    },
    onFileChange: function (event) {

      const file = event.target.files[0]

      if (!file) {
        return false
      }

      if (!file.type.match('image.*') && !file.type.match('application/pdf')) {
        return false
      }

      const reader = new FileReader()
      const that = this
      reader.onload = function (e) {
        that.previewUrl = event.target.files[0];
        that.previewUrlSRC = e.target.result;
      }
      reader.readAsDataURL(file)
    },
    saveInvoice() {
      this.loadSaveInvoice = true
      const config = {
        headers: {'content-type': 'multipart/form-data'},
      }

      let formData = new FormData();
      formData.append('image', this.previewUrl);
      formData.append('catering_id', this.invoice.catering_id);
      formData.append('serial_number', this.invoice.serial_number);
      formData.append('voucher_number', this.invoice.voucher_number);
      formData.append('date', this.invoice.date);
      formData.append('amount', this.invoice.amount);
      formData.append('consolidate_id', this.invoice.consolidate_id);
      formData.append('date_start', this.invoice.date_start);
      formData.append('date_end', this.invoice.date_end);
      formData.append('business_line_id', this.invoice.business_line_id);

      axios.post('invoice/save', formData, config).then(response => {
        if(response.status === 200){
          let index = this.reports.findIndex(item => item.id === this.invoice.consolidate_id)
          this.reports[index].invoice = true
          this.loadSaveInvoice = false
          this.closeModalInvoice()
        }else{
          this.loadSaveInvoice = false
          this.closeModalInvoice()
          Swal('Ops!', 'Error no controlado', 'error')
        }
      }).catch((error) => {
        this.loadSaveInvoice = false
        Swal('Ops!', 'Error al intentar subir la factura', 'error')
        console.log(error)
      })
    },
    updateInvoice() {
      this.loadUpdateInvoice = true
      const config = {
        headers: {'content-type': 'multipart/form-data'},
      }

      let formData = new FormData();
      formData.append('image', this.previewUrl);
      formData.append('catering_id', this.invoice.catering_id);
      formData.append('serial_number', this.invoice.serial_number);
      formData.append('voucher_number', this.invoice.voucher_number);
      formData.append('date', this.invoice.date);
      formData.append('amount', this.invoice.amount);
      formData.append('consolidate_id', this.invoice.consolidate_id);
      formData.append('date_start', this.invoice.date_start);
      formData.append('date_end', this.invoice.date_end);
      formData.append('business_line_id', this.invoice.business_line_id);

      axios.post('invoice/update', formData, config).then(response => {
        if(response.status === 200){
          let index = this.reports.findIndex(item => item.id === this.invoice.consolidate_id)
          this.reports[index].invoice = true
          this.loadUpdateInvoice = false
          this.closeModalUpdateInvoice()
        }else{
          this.loadUpdateInvoice = false
          this.closeModalUpdateInvoice()
          alert('Error Inesperado')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    closeModalInvoice(){
      this.show_invoice = false
      this.invoice.serial_number = ''
      this.invoice.voucher_number = ''
      this.invoice.date = ''
      this.invoice.amount = ''
      this.invoice.consolidate_id = ''
      this.invoice.catering_id = ''
      this.invoice.date_ini = ''
      this.invoice.date_end = ''
      this.previewUrl = ''
      this.invoice.file = ''
    },
    closeModalUpdateInvoice(){
      this.show_update_invoice = false
      this.invoice.serial_number = ''
      this.invoice.voucher_number = ''
      this.invoice.date = ''
      this.invoice.amount = ''
      this.invoice.consolidate_id = ''
      this.invoice.catering_id = ''
      this.invoice.date_ini = ''
      this.invoice.date_end = ''
      this.invoice.file = ''
      this.previewUrl = ''
    },
    getUser() {
      axios.get("auth/me").then((resp) => {
        this.user = resp.data;
      });
    },
    getfirstNLastDayWeek(curr) {
      const today = moment(curr);

      const firstday = today.clone().startOf("isoWeek");
      const lastday = today.clone().endOf("isoWeek");

      let obj = {
        first: moment(firstday).format("DD-MM-YY"),
        last: moment(lastday).format("DD-MM-YY"),
        firstDate: moment(firstday).format("YYYY-MM-DD"),
        lastDate: moment(lastday).format("YYYY-MM-DD"),
      };
      return obj;
    },
    get_pdf_func(item) {
      this.loading_id = item.id;
      console.log(item, moment(item.end).format("YYYY-DD-MM"));
      backofficeApi({
        url: "consolidated/generate_pdf_catering",
        responseType: "blob",
        method: "get",
        params: {
          date_ini: item.start.split("-").reverse().join("-"),
          date_end: item.end.split("-").reverse().join("-"),
          catering_id: item.catering_id,
          business_line_id: item.business_line_id,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "consolidado-" + moment(new Date()).format("YYYY-MM-DD") + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading_id = null;
        });
    },
    get_historic_consolidados(dates=null) {
      backofficeApi
        .get("consolidated/catering_historic", {
          params: {
            catering_id: 1,
            dates
          },
        })
        .then((response) => {
          this.reports = response.data;
        })
        .catch((error) => console.log(error));
    },

    async getInvoice(consolidateId) {

      const params = {
        consolidate_id: consolidateId
      }
      console.log(params);
      try {
        const res = await backofficeApi.get('consolidated/get_invoice', {params});
        const status = res.status;
        const data = res.data;
        if((status >= 200) && (status < 300)){
          this.invoice.serial_number = data.serial_number
          this.invoice.voucher_number = data.voucher_number
          this.invoice.date = data.date
          this.invoice.amount = data.amount
          this.invoice.consolidate_id = data.consolidate_id
          this.invoice.catering_id = data.catering_id
          this.invoice.file = data.file
        }
      } catch (err) {
          console.error(err);
          if (err.response) {
              console.log(err.response);
              const status = err.response.status
              const data = err.response.data
              const message = data.errors ? data.errors.join('<br/>') : ''
              switch (status) {
                  case 409:
                      Swal('Ops!', message, 'error')
                      break;
                  default:
                      Swal('Ops!', message, 'error')
                      break;
              }
          }else{
              Swal('Ops!', 'Error no controlado', 'error')
          }
      }
    },
  },
};
</script>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
